import EditarContaBancariaModal from './EditarContaBancariaModal';

export default EditarContaBancariaModal;
